import { render, staticRenderFns } from "./IncidentsMy.vue?vue&type=template&id=1004583d"
import script from "./IncidentsMy.vue?vue&type=script&lang=js"
export * from "./IncidentsMy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports